import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_manage/manage/')({
  component: () => <Navigate to="/manage/dashboard" />,
})
